"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _events = require("../../utils/events");

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = require("../../utils/icon");

var _convertUnsafeMethod = _interopRequireDefault(require("../../utils/convertUnsafeMethod"));

var _CornerTriangle = _interopRequireDefault(require("../../Icon/core/CornerTriangle"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _focusRing = _interopRequireWildcard(require("../../utils/focusRing"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

require("../style/index.css");

var _class, _class2, _temp;

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css-overrides/button/index.css");

  require("../../spectrum-css-overrides/button/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css-overrides/button/index-lg.css");
} else {
  require("../../spectrum-css-overrides/button/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css-overrides/button/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css-overrides/button/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css-overrides/button/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css-overrides/button/multiStops/darkest.css");
// For backward compatibility with coral
var VARIANTS = {
  quiet: {
    variant: 'primary',
    quiet: true
  },
  minimal: {
    variant: 'secondary',
    quiet: true
  },
  icon: {
    variant: 'action',
    quiet: true
  }
};
/**
 * A **button** represents an action a user can take. Buttons can be clicked or tapped to
 * perform an action or to navigate to another page. Buttons in Spectrum have several variations
 * for different uses and multiple levels of loudness for various attention-getting needs.
 */

var Button = (0, _convertUnsafeMethod["default"])(_class = (0, _focusRing["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Button, _Component);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClick", function (event) {
      // This is needed when `element` is an anchor or something similar.
      // When `element` is a button, we won't even get here if it's disabled and clicked.
      if (_this.props.disabled) {
        // If the element is an anchor with an href, we need to preventDefault() or the browser
        // will follow the link.
        event.preventDefault();
      } else if (_this.props.onClick) {
        var _this$props;

        for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          rest[_key2 - 1] = arguments[_key2];
        }

        (_this$props = _this.props).onClick.apply(_this$props, [event].concat(rest));
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownSpace", function (event) {
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();

        _this.buttonRef.click();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setButtonRef", function (b) {
      return _this.buttonRef = b;
    });
    return _this;
  }

  (0, _createClass2["default"])(Button, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoFocus) {
        // wait a frame to make sure the button in the DOM and focusable
        requestAnimationFrame(function () {
          return _this2.focus();
        });
      }
    }
    /**
     * Focus the button
     */

  }, {
    key: "focus",
    value: function focus() {
      if (this.buttonRef && !this.props.disabled && this.buttonRef.focus) {
        this.buttonRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$element = _this$props2.element,
          Element = _this$props2$element === void 0 ? 'button' : _this$props2$element,
          label = _this$props2.label,
          children = _this$props2.children,
          _this$props2$variant = _this$props2.variant,
          variant = _this$props2$variant === void 0 ? 'secondary' : _this$props2$variant,
          logic = _this$props2.logic,
          quiet = _this$props2.quiet,
          icon = _this$props2.icon,
          selected = _this$props2.selected,
          block = _this$props2.block,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          invalid = _this$props2.invalid,
          onMouseDown = _this$props2.onMouseDown,
          onMouseUp = _this$props2.onMouseUp,
          autoFocus = _this$props2.autoFocus,
          holdAffordance = _this$props2.holdAffordance,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["element", "label", "children", "variant", "logic", "quiet", "icon", "selected", "block", "className", "disabled", "invalid", "onMouseDown", "onMouseUp", "autoFocus", "holdAffordance"]); // Map variants for backwards compatibility

      if (VARIANTS[variant]) {
        var mappedVariant = VARIANTS[variant];
        var variantName = (mappedVariant.quiet ? 'quiet ' : '') + "\"".concat(mappedVariant.variant, "\"");
        console.warn("The \"".concat(variant, "\" variant of Button is deprecated. Please use the ").concat(variantName, " variant instead."));
        variant = mappedVariant.variant;
        quiet = mappedVariant.quiet;
      }

      var shouldRenderHoldAffordance = false; // Some button variants were broken out into their own components, map them appropriately

      var baseButtonClass = 'spectrum-Button';

      if (variant === 'action' || variant === 'toggle') {
        baseButtonClass = 'spectrum-ActionButton';
        shouldRenderHoldAffordance = holdAffordance;

        if (variant === 'toggle') {
          quiet = true;
        }

        variant = '';
      } else if (logic) {
        baseButtonClass = 'spectrum-LogicButton';
      } else if (variant === 'clear') {
        baseButtonClass = 'spectrum-ClearButton';
        variant = '';
      } else if (variant === 'field') {
        baseButtonClass = 'spectrum-FieldButton';
        variant = '';
      } else if (variant === 'tool') {
        baseButtonClass = 'spectrum-Tool'; // hold affordance is really only a part of tool.

        shouldRenderHoldAffordance = holdAffordance;
        variant = '';
      }

      if (Element !== 'button') {
        otherProps.role = 'button';
        otherProps.tabIndex = disabled ? null : otherProps.tabIndex || 0;
        otherProps['aria-disabled'] = disabled || null;

        if (Element === 'a' && disabled && otherProps.href) {
          otherProps.href = null;
        }

        otherProps.onKeyDown = disabled ? null : this.onKeyDownSpace;
      }

      var labelContents = label || (typeof children === 'string' ? children : null);
      var ariaExpanded = null;

      if (otherProps['aria-expanded'] !== undefined) {
        ariaExpanded = otherProps['aria-expanded'];
      } else if (otherProps['aria-haspopup']) {
        ariaExpanded = selected || null;
      }

      var filteredProps = typeof Element === 'string' ? (0, _filterDOMProps["default"])(otherProps) : otherProps;
      return _react["default"].createElement(Element, (0, _extends2["default"])({}, filteredProps, {
        className: (0, _classnames["default"])(baseButtonClass, quiet ? "".concat(baseButtonClass, "--quiet") : '', variant ? "".concat(baseButtonClass, "--").concat(variant) : '', (0, _defineProperty2["default"])({
          'is-selected': selected,
          'is-disabled': disabled,
          'is-invalid': invalid,
          'spectrum-Button--block': block
        }, _focusRing.FOCUS_RING_CLASSNAME, autoFocus), className),
        disabled: disabled,
        "aria-invalid": invalid || null,
        "aria-expanded": ariaExpanded,
        onClick: this.onClick,
        onMouseDown: (0, _events.chain)(this.onMouseDown, _events.focusAfterMouseEvent.bind(this, onMouseDown)),
        onMouseUp: (0, _events.chain)(this.onMouseUp, _events.focusAfterMouseEvent.bind(this, onMouseUp)),
        ref: this.setButtonRef
      }), (0, _icon.cloneIcon)(icon, {
        size: 'S'
      }), labelContents && _react["default"].createElement("span", {
        className: baseButtonClass + '-label'
      }, labelContents), shouldRenderHoldAffordance && _react["default"].createElement(_CornerTriangle["default"], {
        role: "presentation",
        size: null,
        className: "spectrum-Tool-hold"
      }), typeof children !== 'string' && children);
    }
  }]);
  return Button;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /**
   * The variant of button to display
   */
  variant: _propTypes["default"].oneOf(['cta', 'primary', 'secondary', 'warning', 'action', 'toggle', 'and', 'or', 'icon', 'quiet', 'minimal', 'dropdown', 'clear', 'field', 'tool', 'overBackground']),

  /**
   * Whether the button should render using a quiet variant
   */
  quiet: _propTypes["default"].bool,

  /**
   * Whether the button is a logic button variant
   */
  logic: _propTypes["default"].bool,

  /**
   * Whether the button is disabled
   */
  disabled: _propTypes["default"].bool,

  /**
   * Whether the button represents a selected state
   */
  selected: _propTypes["default"].bool,

  /**
   * Whether the button represents an invalid state
   */
  invalid: _propTypes["default"].bool,

  /**
   * An icon to render in the button.
   */
  icon: _propTypes["default"].element,

  /**
   * The label to display in the button
   */
  label: _propTypes["default"].string,

  /**
   * Whether the button is a block element
   */
  block: _propTypes["default"].bool,

  /**
   * The DOM element to use to render the button
   */
  element: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),

  /**
   * Whether the button should be auto focused on mount
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * A click handler for the button
   */
  onClick: _propTypes["default"].func,

  /**
   * A visual variation that puts a small triangle in the lower right
   */
  holdAffordance: _propTypes["default"].bool
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  autoFocus: false,
  block: false,
  disabled: false,
  element: 'button',
  invalid: false,
  label: '',
  logic: false,
  quiet: false,
  selected: false,
  variant: 'secondary',
  holdAffordance: false
}), _temp)) || _class) || _class;

exports["default"] = Button;